// feature_flags.ts — aha_forge v1 build-time feature flag reader.
//
// Source: docs/contracts/aha/feature_flags.aha.v1.yaml (5 flags + 1 kill switch).
// Wire: vite.config.ts loadEnv → import.meta.env.VITE_FYD_AHA_*.
// Truth: BE is canonical; FE flag is a UI rendering hint only. When BE flag
// is OFF its data fields will be null/absent and FE must treat the FE flag as
// a UI gate ANDed with data presence.

export const AHA_FLAG_IDS = [
  'FYD_AHA_ONBOARDING_2STEP',
  'FYD_AHA_EMPTY_STATE_SEDUCTION',
  'FYD_AHA_MAGIC_MOMENTS',
  'FYD_AHA_PROGRESS_REVEAL',
  'FYD_AHA_PERSONALIZATION_CONSENT',
  'FYD_AHA_KILL_SWITCH',
] as const;

export type AhaFlagId = (typeof AHA_FLAG_IDS)[number];

function readEnv(key: string): string {
  // import.meta.env is keyed by string at build time. Cast through unknown to
  // avoid the TS-rejecting `any` lookup; runtime is just a record.
  const env = import.meta.env as unknown as Record<string, string | undefined>;
  return env[key] ?? '';
}

export function getAhaFlag(flag: AhaFlagId): boolean {
  // Master kill switch overrides every individual flag (PR-CONTRACT-04).
  const killed = readEnv('VITE_FYD_AHA_KILL_SWITCH') === '1';
  if (killed && flag !== 'FYD_AHA_KILL_SWITCH') return false;
  return readEnv(`VITE_${flag}`) === '1';
}
